<script lang="ts" setup>
import { useUrlSearchParams } from '@vueuse/core'
import type { BuyerGift, GiftsSentGift, MyPurchasesGift } from '@consumer/types/serializers'

const { gift } = defineProps<{ gift: BuyerGift | GiftsSentGift | MyPurchasesGift }>()

const statusColors: Record<string, string> = {
  Processing: 'text-gold',
  Scheduled: 'text-v2-active',
  Sent: 'text-green-base',
  Opened: 'text-v2-active',
  Shipped: 'text-green-base',
  'Sent to Printer': 'text-green-base',
  Refunded: 'text-red-base',
  Cancelled: 'text-red-base',
  'Delivery Failed': 'text-red-base',
}

const urlParams = useUrlSearchParams()

const label = computed(() => {
  if (urlParams.gift_id === gift.id && [
    'giftly_email_not_delivered_email',
    'giftly_sms_not_delivered_email',
    'mailable_returned_email',
  ].includes(String(urlParams.spec))) {
    return 'Delivery Failed'
  }
  else if (gift.statusLabel === 'Refunded') {
    return 'Cancelled'
  }
  // Only the gifts-sent page tracks whether the recipient opened the gift; it's
  // more informative than "Sent", but a cancellation still outranks it.
  else if ('openedAt' in gift && gift.openedAt) {
    return 'Opened'
  }
  else if (gift.statusLabel === 'Delivered') {
    return gift.delivery.deliveryMethod === 'mail' ? 'Shipped' : 'Sent'
  }
  return gift.statusLabel
})
</script>

<template>
  <div
    v-if="gift.statusLabel"
    class="
      font-semibold text-xs rounded-full
      py-1 px-2
      capitalize
      bg-opacity-10 whitespace-nowrap
      flex gap-1 items-center justify-center
    "
    :class="statusColors[label] || 'text-v2-tertiary'"
    style="background: color-mix(in oklab, currentcolor, white 90%);"
  >
    <LoadingIndicator v-if="label === 'Processing'"/>
    {{ label }}
  </div>
</template>
